import { otto } from "../../../exports/nexus.js";
import type { NexusResult } from "../../nexus/function/function.types";
import type { WithMacrotaskOptions } from "../async/promise.types";
/*                                                         */
import type { CoreRaw } from "../index.js";

const { runWithMacrotask, runWithRenderSlice } = otto.grcore;

/**
 *
 *
 *
 */
export type DecoratedFunction<A extends unknown[], R> = (...fnArgs: A) => NexusResult<Awaited<R>>;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const withMacrotask =
  <A extends unknown[], R>(
    fn: (...args: A) => R,
    options?: WithMacrotaskOptions,
  ): DecoratedFunction<A, R> =>
  (...fnArgs: A) =>
    runWithMacrotask(fn, options, ...fnArgs);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const withRenderSlice =
  <A extends unknown[], R>(
    fn: (this: Parameters<FrameRequestCallback>[0], ...args: A) => R,
    options: WithMacrotaskOptions = {},
  ): DecoratedFunction<A, R> =>
  (...fnArgs) =>
    runWithRenderSlice(fn, options, ...fnArgs);
